// @flow
import React, { Children, Fragment, Component, createRef, type Node } from 'react';

import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { Toggler } from 'Components/frameworks/toggler/Toggler.jsx';
import { scrollToElement } from 'Components/utils/scroll/scrollToElement';

import { themes } from './SeeMore.themes';

export type SeeMoreProps = {
  children: Node,
  className?: string,
  classNameButton?: string,
  hasNoScrollOnCollapse?: boolean,
  isCollapseEnabled?: boolean,
  offsetScrollSelector?: string,
  onClick?: (SyntheticEvent<>) => void,
  seeLessLabel?: string,
  seeMoreLabel?: string,
  seeMoreSize?: number,
  theme?: string,
};

type State = {
  height: ?number,
  isCollapsable: boolean,
};

export class SeeMore extends Component<SeeMoreProps, State> {
  wrapperRef: { current: HTMLDivElement | null };
  static defaultProps = {
    offsetScrollSelector: '.NavigationNarrow.Navigation-bar',
    onClick: () => {},
    seeLessLabel: '',
    seeMoreLabel: '',
    seeMoreSize: 120,
  };

  constructor(props: SeeMoreProps) {
    super(props);
    this.state = {
      height: null,
      isCollapsable: false,
    };

    this.wrapperRef = createRef();
  }

  getIsCollapsableState(height: ?number) {
    this.setState({
      isCollapsable:
        Number(height) - Number(this.props.seeMoreSize) > 0 && !!this.props.isCollapseEnabled,
    });
  }

  componentDidMount() {
    const height = this.wrapperRef.current && this.wrapperRef.current.clientHeight;
    this.setState({
      height,
    });
    this.getIsCollapsableState(height);
  }

  componentDidUpdate(prevProps: SeeMoreProps, prevState: State) {
    if (prevProps.isCollapseEnabled !== this.props.isCollapseEnabled) {
      this.getIsCollapsableState(prevState.height);
    }
  }

  render() {
    const {
      children,
      className,
      classNameButton,
      hasNoScrollOnCollapse,
      offsetScrollSelector,
      onClick,
      seeLessLabel,
      seeMoreLabel,
      seeMoreSize,
      theme = 'default',
    } = this.props;

    if (!Children.count(children)) {
      return null;
    }

    const { height, isCollapsable } = this.state;
    const { thBlurStyle, thButton } = themes[theme];

    return (
      <Toggler>
        {(toggle, isActive) => (
          <Fragment>
            <div className={className} ref={this.wrapperRef}>
              <div
                className="overflow-hidden relative transition-heights"
                style={
                  !isActive && isCollapsable
                    ? {
                        height: `${Number(seeMoreSize)}px`,
                      }
                    : { height }
                }
              >
                {children}
                {!isActive &&
                  isCollapsable && <div className="absolute bottom-0 w-full" style={thBlurStyle} />}
              </div>
            </div>
            {isCollapsable && (
              <div className={classNameButton}>
                <button
                  className={thButton}
                  onClick={() => {
                    toggle();
                    if (isActive && !hasNoScrollOnCollapse) {
                      scrollToElement(this.wrapperRef.current, 300, offsetScrollSelector);
                    }
                    // $FlowFixMe stupido flow, onClick is in defaultProps
                    onClick();
                  }}
                  type="button"
                >
                  {// $FlowFixMe
                  isActive ? seeLessLabel : seeMoreLabel}
                  <Icon className="mx-1" name={isActive ? ICONS.MINUS : ICONS.PLUS} width="0.7em" />
                </button>
              </div>
            )}
          </Fragment>
        )}
      </Toggler>
    );
  }
}
